import type { TFunction } from 'i18next';

import { DATE_ISO } from '@/js/libs/api-helpers';
import dayjs from '@/js/libs/dayjs';

import type { ParamsValidator } from 'src/components/RouteParamsValidator.tsx';
import type { PayoutsRouteParams } from './types.ts';

const DATE_REG_EXP = /^\d{4}-\d{2}-\d{2}$/;

export const validatePayoutDate: ParamsValidator<Required<PayoutsRouteParams>> = ({ date }) => DATE_REG_EXP.test(date);

export const getFirstDayOfCurrentMonth = () => {
  const firstDayOfMonth = dayjs().date(1).format(DATE_ISO);

  return firstDayOfMonth;
};

export type ModificationAmountType = 'NET_5' | 'NET_4';

export const formatModificationAmountLabel = (t: TFunction, amountType: ModificationAmountType, currency?: string) => {
  const label = amountType === 'NET_4' ? t('common:AMOUNT_NET4') : t('common:AMOUNT_NET5');
  return currency ? `${label} (${currency})` : label;
};

export const toModificationAmount = (amountType: ModificationAmountType, amount: number) =>
  amountType === 'NET_4' ? { amountNet4: amount } : { amountNet5: amount };
